import { Parser, ParseResult } from "../types";

export const jsonParser: Parser = {
  name: "json",
  priority: 3,
  parse: (content: string): ParseResult<Record<string, unknown>> => {
    try {
      const parsed = JSON.parse(content);

      if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
        return { success: false, data: null, format: "json", error: "JSON must be an object" };
      }

      // Check for Kubernetes Secret format with .data field
      if ("data" in parsed && typeof parsed.data === "object" && parsed.data !== null) {
        return { success: true, data: parsed.data, format: "json" };
      }

      return { success: true, data: parsed, format: "json" };
    } catch (e) {
      return { success: false, data: null, format: "json", error: e.message };
    }
  },
};
